// Navigation URL constants for user lists component
export const NAVIGATION_URLS = {
  VIEW_ALL_LISTS: '/list/view/summary',
  LEARN_MORE: '/c/create-a-list',
};